export enum RegisterAsInspector {
 single = 1,
 facility = 2
}
